import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import BoreSizeManagement from './pages/BoreSizeManagement';
import PriceSlabManagement from './pages/PriceSlabManagement';
import EnquiriesManagement from './pages/EnquiriesManagement';
import ItemManagement from './pages/ItemManagement';
import QuotationManagement from './pages/QuotationManagement';
import QuotationView from './pages/QuotationView';
import LogSheetManagement from './pages/LogSheetManagement';
import InvoiceManagement from './pages/InvoiceManagement';
import InvoiceView from './pages/InvoiceView';
import ProfileSettings from './pages/ProfileSettings';
import Reports from './pages/Reports';
import RigManagement from './pages/RigManagement';
import ServiceCalendar from './pages/ServiceCalendar';
import ToastProvider from './components/UI/Toast';

function App() {
  return (
    <Router>
      <AuthProvider>
        <ToastProvider />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route 
            path="/dashboard" 
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/users" 
            element={
              <PrivateRoute>
                <UserManagement />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/bore-sizes" 
            element={
              <PrivateRoute>
                <BoreSizeManagement />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/price-slabs" 
            element={
              <PrivateRoute>
                <PriceSlabManagement />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/enquiries" 
            element={
              <PrivateRoute>
                <EnquiriesManagement />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/items" 
            element={
              <PrivateRoute>
                <ItemManagement />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/quotations" 
            element={
              <PrivateRoute>
                <QuotationManagement />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/quotations/:id" 
            element={
              <PrivateRoute>
                <QuotationView />
              </PrivateRoute>
            } 
          />
          <Route
            path="/log-sheets"
            element={
              <PrivateRoute>
                <LogSheetManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <PrivateRoute>
                <InvoiceManagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/invoices/:id"
            element={
              <PrivateRoute>
                <InvoiceView />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <ProfileSettings />
              </PrivateRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <PrivateRoute>
                <Reports />
              </PrivateRoute>
            }
          />
          <Route
            path="/service-calendar"
            element={
              <PrivateRoute allowedRoles={['ADMIN']}>
                <ServiceCalendar />
              </PrivateRoute>
            }
          />
          <Route
            path="/rigs"
            element={
              <PrivateRoute>
                <RigManagement />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
